<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Born in London in 1964, Mel Walsh spent her childhood in the London Borough of Hackney. In 1983, she trained as a registered nurse at St Bartholomew’s Hospital, London, and then as a midwife at The Homerton Hospital, London. She had a varied career, including working as a practice nurse in busy GP practices in Islington and Newham, and as a volunteer midwife in Lebanon during Civil War. After retiring from nursing, she moved to the west country. <em>Prior</em> <em>Knowledge</em> is her debut novel.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?5ff47ee7